import { AdGroupBean } from 'common/api/api'
import { camelCaseToWords } from 'common/util/Util'
import { FC } from 'react'
import { DictionarySelector, DictionarySelectorProps } from './DictionarySelector'
import BrandSafetyEnum = AdGroupBean.BrandSafetyEnum

export const BrandSafetySelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="browser" loader={() => Promise.resolve(Object.keys(BrandSafetyEnum).map(item => ({ id: item, name: camelCaseToWords(item) })))} mode="multiple" />